import { PageHeader } from '@/components/ui'
import { DispositionCalendar } from './components/DispositionCalendar'

export function DispoKalenderPage() {
  return (
    <div className="p-6 space-y-4">
      <PageHeader title="Kalenderübersicht" />
      <DispositionCalendar mode="week" showHeader showEmployeeImages />
    </div>
  )
}
